var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.583 4.417v3.666h-.666V5.562l-3.709 3.709q.375.562.625 1.177.25.614.25 1.302 0 1.604-1.114 2.719-1.115 1.114-2.719 1.114-1.604 0-2.719-1.114-1.114-1.115-1.114-2.719 0-1.604 1.114-2.719Q6.646 7.917 8.25 7.917q.708 0 1.312.239.605.24 1.167.636l3.709-3.709h-2.521v-.666ZM8.25 8.583q-1.312 0-2.24.927-.927.928-.927 2.24 0 1.312.927 2.24.928.927 2.24.927 1.312 0 2.24-.927.927-.928.927-2.24 0-1.312-.927-2.24-.928-.927-2.24-.927Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale);
export default __webpack_public_path__ + "static/media/male.986f89c0b18dc91bf16fad1482c659df.svg";
export { ForwardRef as ReactComponent };